import {
  selectEditingCollection,
  setSelectedMenu,
  setSelectedMenuId,
} from "../../redux/features/appData";
import "./AskedQuestionsZero.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MENUS } from "../config/menus";
import { useSelector } from "react-redux";

type AskedQuestionsZeroProps = {};

export const AskedQuestionsZero = ({}: AskedQuestionsZeroProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentCollection = useSelector(selectEditingCollection);

  return (
    <div className="asked-questions-zero">
      <div className="asked-questions-zero-header">No questions yet</div>

      <div className="asked-questions-zero-icon">
        <button
          onClick={() => {
            dispatch(setSelectedMenu(MENUS.COLLECTION_ASK));
            dispatch(setSelectedMenuId(null));
            navigate("/collection/" + currentCollection?.id);
          }}>
          Ask a Question
        </button>
      </div>
    </div>
  );
};
